export function dynamicSort (property) {
  let sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
    return result * sortOrder
  }
}

export const groupBy = (array, key) => {
  // Return the reduced array
  return array.reduce((result, currentItem) => {
    // If an array already present for key,
    // push it to the array. Otherwise create an array and push the object.
    (result[currentItem[key]] = result[currentItem[key]] || []).push(currentItem)
    // return the current iteration `result` value,
    // this will be the next iteration's `result` value and accumulate
    return result
  }, {}) // Empty object is the initial value for result object
}
